export default __webpack_public_path__ + "static/all-buttons-light-e815a2ef7e5b29b89087e92e55fb269f.png";